
export const MediaQuery = {
    MIN_DESKTOP: 960,
    MAX_MOBILE: 959
};